import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  agreement: false,
};

// Slice
const agreeProductSlice = createSlice({
  name: "agreeProduct",
  initialState,
  reducers: {
    initProductCheckAgree(state) {
      return { ...state, agreement: false };
    },
    productCheckAgree(state, action) {
      const { agreement } = action.payload;
      return { ...state, agreement };
    },
  },
});

export const { initProductCheckAgree, productCheckAgree } =
  agreeProductSlice.actions;

export default agreeProductSlice.reducer;
